import httpClient from 'shared/lib/httpClient';

export const createTariffBook = async (payload) => {
  const response = await httpClient.post('/tariff-books', payload);
  return response?.data;
};
